<template>
  <v-text-field
    v-model="search"
    class="search-bar"
    prepend-inner-icon="mdi-magnify"
    placeholder="Caută în tabel"
    aria-label="Caută în tabel"
    outlined
    dense
    single-line
    hide-details
    clearable
  ></v-text-field>
</template>

<script>
export default {
  data() {
    return {
      search: "",
    };
  },
  watch: {
    search: function (newSearchValue) {
      this.$emit("search", newSearchValue || "");
    },
  },
};
</script>

<style scoped>
.search-bar {
  flex: 0 1 300px;
  min-width: 170px;
}
.search-bar ::v-deep .v-input__slot {
  min-height: 44px !important;
  background: var(--mint-50);
}
</style>
